import apiService from '../apiService';

const COMPANY_URL = 'companies';
const companiesService = {

    async createCompany(payload) {
        try {
            const response = await apiService.post(`/${COMPANY_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllCompanies(params = {}) {
        try {
            const response = await apiService.get(`/${COMPANY_URL}`, {
                params
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getACompany(id) {
        try {
            const response = await apiService.get(`/${COMPANY_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // For company admin's company billing summary
    async getSeatSummary() {
        try {
            const response = await apiService.get(`/${COMPANY_URL}/seats/summary`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getCompanyBillingSummary(id) {
        try {
            const response = await apiService.get(`/${COMPANY_URL}/billing/dashboard/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // For company admin's company billing summary
    async createRenewalCheckout() {
        try {
            const response = await apiService.post(`/${COMPANY_URL}/renewal-checkout`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateCompany(id, payload) {
        try {
            const response = await apiService.patch(`/${COMPANY_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteCompany(id) {
        try {
            const response = await apiService.delete(`/${COMPANY_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async createSubscriptionCheckout(payload) {
        try {
            const response = await apiService.post(`/${COMPANY_URL}/checkout`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async confirmSubscriptionCheckout(session_id) {
        try {
            const response = await apiService.post(`/${COMPANY_URL}/checkout/confirm`, { session_id });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async createBillingPortalSession() {
        try {
            const response = await apiService.post(`/${COMPANY_URL}/billing-portal`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async previewInvoice(id, isDownload = false, template = 1) {
        try {
            const response = await apiService.get(`/admin/invoice/${id}?download=${isDownload ? '1' : '0'}&template=${template}`, {
                responseType: 'blob',
                isPdf: true
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async superAdminPreviewInvoice(id, isDownload = false, template = 1) {
        try {
            const response = await apiService.get(`/super-admin/invoice/${id}?download=${isDownload ? '1' : '0'}&template=${template}`, {
                responseType: 'blob',
                isPdf: true
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async sendInvoice(id, payload) {
        try {
            const response = await apiService.post(`/admin/billing-invoice/send/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};
export default companiesService;
